import ReportManagerIcon from './component'

export default ReportManagerIcon
